import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"

import getAnimationData from "./getAnimationData"
import { animatedModules } from "../constants"
import TileContainer from "./TileContainer"
import ModuleIcon from "./ModuleIcon"

const ModuleIconWrapper = ({ dispatch, module, iconName }) => {
  const [animation, setAnimation] = useState(null)
  const isAnimatedModule = animatedModules.includes(module)

  useEffect(() => {
    async function fetchData() {
      if (isAnimatedModule) {
        const value = await getAnimationData({ module, iconName })
        setAnimation(value)
      }
    }
    fetchData()
  }, [])

  if (!isAnimatedModule)
    return (
      <img
        src={`/private/shared/${module}/${iconName}.svg`}
        alt={`homepage tile icon for module ${module}`}
      />
    )

  if (!animation) return null

  return iconName === "largeIcon" ? (
    <TileContainer>
      <ModuleIcon
        dispatch={dispatch}
        module={module}
        animation={animation}
        iconName={iconName}
      />
    </TileContainer>
  ) : (
    <ModuleIcon
      dispatch={dispatch}
      module={module}
      animation={animation}
      iconName={iconName}
    />
  )
}
ModuleIconWrapper.propTypes = {
  dispatch: PropTypes.func.isRequired,
  module: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
}

export default ModuleIconWrapper
